import { createSlice } from '@reduxjs/toolkit';

const initialState = { items: [] };

// items = {key:{count:"",info:""}}
export const cart = createSlice({
    name: 'cart',
    initialState,
    reducers: {
        _setItems: (state, action) => {
            return { ...state, items: action.payload };
        }
    },
});

export const { _setItems } = cart.actions;

export default cart.reducer;
